import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    const original = this.bannerTarget.querySelector("img")

    const clone = original.cloneNode(true)
    clone.classList.add("clone")
    this.bannerTarget.appendChild(clone)

    const width = original.offsetWidth
    this.element.style.setProperty("--banner-width", width + "px")

    const speed = 30
    const duration = width / speed
    this.element.style.setProperty("--duration", duration + "s")
  }
}
